import React, { Fragment, useEffect, useRef, useState } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectIsLoading,
  makeSelectIsEngagement,
  makeSelectIsEngagementOnly,
  makeSelectDimensions,
  makeSelectOutcomes,
  makeSelectMetricTotal,
  makeSelectShowHistory,
  makeSelectShowDimensionBenchmark,
  makeSelectSwitchMoreDimensions,
  makeSelectDivisionsAvailable,
  makeSelectAmbassadorBenchmarkVisible,
  makeSelectMeasureInfo,
  makeSelectDivisions,
  makeSelectIsLoadingGraphicBars,
  makeSelectGraphicBars,
  makeSelectIsLoadingGraphicPeakon,
  makeSelectGraphicPeakons,
  makeSelectAmbassadors,
  makeSelectMeasureRangeColor,
  makeSelectEvolutionData,
  makeSelectEvolutionLines,
  makeEmployeesTotal,
  makeSelectDivisionsTotal,
  makeSelectIfFirst,
  makeSelectQuestions
} from "./selectors"
import {
  getAmbassadorsWatcher,
  getDimensionsMeasureColorRangeWatcher,
  getDimensionsWatcher,
  getDivisionsWatcher,
  getHistoryByDivisionWatcher,
  graphicBarsWatcher,
} from "./actions"

import "./index.less"
import { Layout, Spin, Radio } from "antd"
import { Helmet } from "react-helmet"
import BlockFreemiumPageBlur from "../../../components/BlockFreemiumPageBlur"
import {
  isModuleBySlug,
  isModeInModuleBySlug,
  KEY_CHECKBOX_EXCLUDE,
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
  setItem,
  isAmbassadorActive,
} from "../../../utils/storage"
import {
  HISTORICAL_ANALYSIS,
  BENCHMARK,
  IMPACT_ANALYSIS,
  ENABLE,
} from "../../../utils/constants"
import { validate } from "../../../utils/functions"
import EmptyStateAnonymity from "../../../components/EmptyStateAnonymity"
import { get, isNaN } from "lodash"
import ResultByDimensionV2 from "../../../components/ResultByDimensionV2"
import MeasurementColorRange from "../../../components/MeasurementColorRange"
import HeaderDimension from "../../../components/HeaderDimension"
import ContentTopDimension from "../../../components/ContentTopDimension"
import { loadTexts } from "../../../utils/i18n"
import ResultByQuestion from "../../../components/ResultByQuestion"
import { verifyFeatureFlag } from "../../../utils/feature-flags"

function usePreviousMeasureID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

function usePreviousDivisionID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export function DimensionByDivision(props) {
  const intlDimensionByDivision = loadTexts("reports_dimensions_view")
  const searchLocation = getUrlParams(location.search) || {}
  const [measureID] = useState(parseInt(props.match.params.id))
  const [divisionID] = useState(props.match.params.idDivision)
  const [idDivision] = useState(
    searchLocation
      ? validate.exist(searchLocation.id_division) &&
        !validate.empty(searchLocation.id_division)
        ? searchLocation.id_division
        : props.match.params.idDivision
      : props.match.params.idDivision
  )
  const [idDivisionParent] = useState(
    searchLocation
      ? validate.exist(searchLocation.id_divisionParent) &&
        !validate.empty(searchLocation.id_divisionParent)
        ? searchLocation.id_divisionParent
        : null
      : null
  )
  const [idSegment] = useState(
    searchLocation
      ? validate.exist(searchLocation.id_segment) &&
        !validate.empty(searchLocation.id_segment)
        ? searchLocation.id_segment
        : null
      : null
  )
  const prevMeasureID = usePreviousMeasureID(measureID)
  const prevDivisionID = usePreviousDivisionID(divisionID)
  const [selectedTableView, setSelectedTableView] = useState("dimensions")
  const [selectedDivision, setSelectedDivision] = useState(idDivision)
  const [checkboxExclude, setCheckboxExclude] = useState(
    LOCAL_CHECKBOX_EXCLUDE() == "true" && LOCAL_ISOLATED_METRICS() == "true"
  )
  const [isHistoricalAnalysis] = useState(isModuleBySlug(HISTORICAL_ANALYSIS))
  const [isBenchmark] = useState(isModuleBySlug(BENCHMARK))
  const [impactAnalysis] = useState(isModeInModuleBySlug(IMPACT_ANALYSIS))

  useEffect(() => {
    if (prevMeasureID !== measureID) {
      initGetData()
    } else {
      if (prevDivisionID !== divisionID) {
        initGetData()
      }
    }
  }, [props.match.params.id, props.match.params.idDivision])


  useEffect(() => {
    loadDetails()
  }, [
    props.isEngagement,
    props.isEngagementOnly,
    checkboxExclude,
    selectedDivision,
  ])

  const initGetData = async () => {
    const {
      getMeasureColorRangeWatcher,
      getHistoryWatcher,
      getAmbassadors,
    } = props
    getMeasureColorRangeWatcher({ measure: measureID })
    if ((idDivision || divisionID) !== "all") {
      if (
        parseInt(get(searchLocation, "id_segment", 0)) !== 0 ||
        get(props.measureInfo, "segments", []).length === 0
      ) {
      }
    validRole({
          role: [1, 2, 3, 4],
        }) ? getAmbassadors({
        idDivision,
        idSegment,
      }) : ''
      // setSelectedDivision(idDivision)
    } else {
      // setSelectedDivision(idDivision)
    }
  }

  const loadDetails = (onlyDimension = false) => {
    const {
      isEngagement,
      getDivisions,
      getDimensions,
      graphicBarsWatcher,
      getHistoryWatcher,
    } = props

    getDivisions({
      idMeasure: measureID,
      params: {
        id_division: validate.empty(selectedDivision)
          ? idDivision
          : selectedDivision,
        id_segment: idSegment,
        isExclude: checkboxExclude,
      },
      isExclude: checkboxExclude,
      id_division: divisionID,
    })

    getDimensions({
      idDivision: selectedDivision || idDivision,
      idSegment,
      idDivisionParent,
      idMeasure: measureID,
      selectedDivision: selectedDivision || idDivision,
      isEngagement,
      isExclude: checkboxExclude,
      onlyDimension,
    })
    if (!isAmbassadorActive()) {
      if(divisionID == 'all' && idDivision == 'all' && selectedDivision == 'all'){
        graphicBarsWatcher({
          idMeasure: measureID,
          switchBars: isHistoricalAnalysis ? 1 : 0,
          idDivision,
          idDivisionParent,
          idSegment,
          isExclude: checkboxExclude,
        })
      }
    }

    if ((idDivision || divisionID) !== "all") {
      if (
        parseInt(get(searchLocation, "id_segment", 0)) !== 0 ||
        get(props.measureInfo, "segments", []).length === 0
      ) {
        getHistoryWatcher({
          idMeasure: measureID,
          idDivision,
          idDivisionParent,
          idSegment,
          isExclude: checkboxExclude,
        })
      }
    }

  }

  const renderHeader = () => {
    const {
      measureInfo,
      employeesTotal,
      divisionsTotal,
      divisions,
    } = props

    let selectedDivisionInfo = null
    if (validate.exist(selectedDivision) && divisions) {
      selectedDivisionInfo = props.divisions.find(
        (item) => item.id_division == selectedDivision
      )
    }
    return (
      <HeaderDimension
        measureInfo={measureInfo}
        selectedDivisionInfo={selectedDivisionInfo}
        checkboxExclude={checkboxExclude}
        changeDivision={changeDivision}
        changeExcludeCheckbox={changeExcludeCheckbox}
        searchLocation={searchLocation}
        employeesTotal={employeesTotal}
        divisionsTotal={divisionsTotal}
        divisions={divisions || []}
        selectedDivision={selectedDivision}
      />
    )
  }

  const changeExcludeCheckbox = (e) => {
    setItem(KEY_CHECKBOX_EXCLUDE, e.target.checked)
    setCheckboxExclude(e.target.checked)
    // loadDetails()
  }

  const changeDivision = (value) => {
    const {
      match: { params },
    } = props
    validRole({
      role: [1, 2, 3, 4],
    }) ? props.getAmbassadors({ idDivision: value }) : ''
    setSelectedDivision(value)
    let paramsQuery = searchLocation
    if (value) {
      if (
        parseInt(searchLocation.id_segment) !== 0 ||
        get(props.measureInfo, "segments", []).length === 0
      ) {
        props.getHistoryWatcher({
          idMeasure: measureID,
          idDivision: value,
          idDivisionParent,
          idSegment,
          isExclude: checkboxExclude,
        })
      }
      if (paramsQuery) {
        paramsQuery.id_division = value
      } else {
        paramsQuery = {}
        paramsQuery.id_division = value
      }
      paramsQuery = Object.keys(paramsQuery)
        .map((key) => `${key}=${paramsQuery[key]}`)
        .join("&")
    } else {
      paramsQuery = ""
      if (searchLocation.id_segment) {
        paramsQuery = `id_segment=${searchLocation.id_segment}`
      }
    }

    props.history.push(
      `/reports/measure/${params.id}/divisions/${params.idDivision ||
        "all"}/dimensions?${paramsQuery}`
    )
  }

  const renderContent = () => {
    const { metricTotal } = props
    const anonymityValidate =
      metricTotal &&
      metricTotal.anonymity_check &&
      !metricTotal.anonymity_check.valid
      const extraStyle =
  typeof window.Intercom !== "undefined" && window.self === window.top
    ? { paddingBottom: "42px" }
    : {}
    if (anonymityValidate) {
      return <EmptyStateAnonymity count={get(metricTotal, "employees", 0)} />
    }
    return (
      <div className="DimensionByDivision-Content" >
        {renderContentTop()}
        {renderContentBottom()}
      </div>
    )
  }

  const renderContentTop = () => {
    const {
      divisions,
      metricTotal,
      outcomes,
      isEngagement,
      isEngagementOnly,
      measureInfo,
      switchMoreDimensions,
      showHistory,
      match,
      graphicBarsWatcher,
      isLoadingGraphicBars,
      graphicBars,
      isLoadingGraphicPeakon,
      evolutionData,
      evolutionLines,
      ambassadors,
    } = props

    if (
      isNaN(parseInt(searchLocation.id_segment)) &&
      get(measureInfo, "segments", []).length > 1
    ) {
      return null
    }
    return (
      <ContentTopDimension
        divisions={divisions || []}
        metricTotal={metricTotal}
        match={match}
        outcomes={outcomes}
        selectedDivision={selectedDivision}
        isEngagement={isEngagement}
        isEngagementOnly={isEngagementOnly}
        measureInfo={measureInfo}
        switchMoreDimensions={switchMoreDimensions}
        showHistory={showHistory}
        isLoadingGraphicBars={isLoadingGraphicBars}
        graphicBars={graphicBars}
        graphicBarsWatcher={graphicBarsWatcher}
        isLoadingGraphicPeakon={isLoadingGraphicPeakon}
        evolutionData={evolutionData}
        evolutionLines={evolutionLines}
        ambassadors={ambassadors}
        idSegment={idSegment}
      />
    )
  }

  const renderContentBottom = () => {
    const {
      divisions,
      dimensions,
      measureInfo,
      showHistory,
      showDimensionBenchmark,
      measureColorRange,
      switchMoreDimensions,
      isLoading,
      ifFirst,
      questionList
    } = props
    return (
      <Fragment>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "16px",
            paddingRight: "4px",
          }}>
            {verifyFeatureFlag('lip') && <div>
              <span style={{
                fontWeight: 600,
                fontSize: "13px",
                lineHeight: "17px",
                marginRight: "8px",
              }}>
                {intlDimensionByDivision.headerDimension.displayBy}
              </span>
              <Radio.Group
              options={[{label: intlDimensionByDivision.contentBottomDimension.resultByQuestion.columns.dimensions, value: 'dimensions'}, {label: intlDimensionByDivision.contentBottomDimension.resultByQuestion.columns.questions, value:'questions'}]}
              value={selectedTableView}
              optionType="button"
              onChange={(e) => {setSelectedTableView(e.target.value)}}
              />
            </div>}
          <div style={{ width: "max-content" }}>
            <MeasurementColorRange measureColorRange={measureColorRange} />
          </div>
        </div>
        {selectedTableView === 'dimensions' &&
        <ResultByDimensionV2
          //   divisions={divisions}
          showDimensionBenchmark={showDimensionBenchmark}
          measureInfo={measureInfo}
          measureColorRange={measureColorRange}
          showHistory={showHistory}
          data={dimensions}
          isLoading={isLoading}
          ifFirst={ifFirst}
          showVariation={
            isHistoricalAnalysis && showHistory && switchMoreDimensions
          }
          bubble={props.isEngagement && impactAnalysis === ENABLE}
          showBenchmark={
            (isAmbassadorActive() ? props.ambassadorBenchmarkVisible : true) &&
            isBenchmark &&
            props.showDimensionBenchmark
          }
          isExpandable
          idSegment={idSegment}
        />}
        {selectedTableView === 'questions' &&
        <ResultByQuestion
          data={questionList}
          measureInfo={measureInfo}
          measureColorRange={measureColorRange}
          showHistory={showHistory}
          isLoading={isLoading}
          ifFirst={ifFirst}
          showVariation={
            isHistoricalAnalysis && showHistory && switchMoreDimensions
          }
          bubble={props.isEngagement && impactAnalysis === ENABLE}
          idSegment={idSegment}
        />
        }
      </Fragment>
    )
  }

  if (props.isLoading) {
    return (
      <Fragment>
        <div className="DimensionByDivision loadingSpin">
          <Spin size="large" />
        </div>
      </Fragment>
    )
  }

  return (
    <Layout>
      <Helmet>
        <title>{intlDimensionByDivision.titlePage}</title>
        <meta name="description" content="Description of DimensionByDivision" />
      </Helmet>
      <div className="DimensionByDivision">
        <div className="DimensionByDivision-Container" style={{marginBottom:82}}>
          {renderHeader()}
          {renderContent()}
        </div>
      </div>
      <BlockFreemiumPageBlur view="engagement-result-dimension" />
    </Layout>
  )
}

DimensionByDivision.propTypes = {
  isLoading: PropTypes.bool,
  match: PropTypes.object,
  location: PropTypes.object,
  isEngagement: PropTypes.bool,
  isEngagementOnly: PropTypes.bool,
  divisions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  dimensions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  outcomes: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  metricTotal: PropTypes.object,
  showHistory: PropTypes.bool,
  showDimensionBenchmark: PropTypes.bool,
  switchMoreDimensions: PropTypes.bool,
  divisionsAvailable: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  measureInfo: PropTypes.object,
  ambassadorBenchmarkVisible: PropTypes.bool,
  graphicBarsWatcher: PropTypes.func,
  getMeasureColorRangeWatcher: PropTypes.func,
  getHistoryWatcher: PropTypes.func,
  getAmbassadors: PropTypes.func,
  getDivisions: PropTypes.func,
  isLoadingGraphicBars: PropTypes.bool,
  graphicBars: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  isLoadingGraphicPeakon: PropTypes.bool,
  evolutionData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  evolutionLines: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  ambassadors: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  measureColorRange: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  isEngagement: makeSelectIsEngagement(),
  isEngagementOnly: makeSelectIsEngagementOnly(),
  dimensions: makeSelectDimensions(),
  divisions: makeSelectDivisions(),
  divisionsTotal: makeSelectDivisionsTotal(),
  outcomes: makeSelectOutcomes(),
  metricTotal: makeSelectMetricTotal(),
  showHistory: makeSelectShowHistory(),
  ifFirst: makeSelectIfFirst(),
  showDimensionBenchmark: makeSelectShowDimensionBenchmark(),
  switchMoreDimensions: makeSelectSwitchMoreDimensions(),
  divisionsAvailable: makeSelectDivisionsAvailable(),
  measureInfo: makeSelectMeasureInfo(),
  ambassadorBenchmarkVisible: makeSelectAmbassadorBenchmarkVisible(),
  isLoadingGraphicBars: makeSelectIsLoadingGraphicBars(),
  graphicBars: makeSelectGraphicBars(),
  isLoadingGraphicPeakon: makeSelectIsLoadingGraphicPeakon(),
  ambassadors: makeSelectAmbassadors(),
  measureColorRange: makeSelectMeasureRangeColor(),
  evolutionData: makeSelectEvolutionData(),
  evolutionLines: makeSelectEvolutionLines(),
  employeesTotal: makeEmployeesTotal(),
  questionList: makeSelectQuestions(),
})

function mapDispatchToProps(dispatch) {
  return {
    graphicBarsWatcher: (params) => dispatch(graphicBarsWatcher(params)),
    getMeasureColorRangeWatcher: (params) =>
      dispatch(getDimensionsMeasureColorRangeWatcher(params)),
    getHistoryWatcher: (params) =>
      dispatch(getHistoryByDivisionWatcher(params)),
    getAmbassadors: (params) => dispatch(getAmbassadorsWatcher(params)),
    getDivisions: (params) => dispatch(getDivisionsWatcher(params)),
    getDimensions: (params) => dispatch(getDimensionsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "dimensionByDivision", reducer })
const withSaga = injectSaga({ key: "dimensionByDivision", saga })

export default compose(withReducer, withSaga, withConnect)(DimensionByDivision)
